import { avatarColorClass } from '../lib/avatarColor'

function getInitials(name: string, phone: string): string {
  const trimmed = name.trim()
  if (trimmed) {
    const [first, second] = trimmed.split(/\s+/)
    return ((first?.[0] ?? '') + (second?.[0] ?? '')).toUpperCase()
  }
  return phone.slice(-2)
}

interface Props {
  name: string
  phone: string
  size?: 'sm' | 'md'
}

export function Avatar({ name, phone, size = 'md' }: Props) {
  const colorClass = avatarColorClass(phone)
  const sizeClass = size === 'sm' ? 'h-8 w-8 text-xs' : 'h-10 w-10 text-sm'

  return (
    <div
      className={`flex shrink-0 items-center justify-center rounded-full font-semibold ${sizeClass} ${colorClass}`}
    >
      {getInitials(name, phone)}
    </div>
  )
}
